// @owners { team: patients }
import { createSelector } from 'reselect';
import { getNextAvailableDateID } from '~shared/features/next-available-date/helpers/getNextAvailableDateID';
import { getNextAvailableDateFacilityID } from '~shared/features/next-available-date/selectors/getNextAvailableDateFacilityId';
import { getNextAvailableDates } from '~shared/features/next-available-date/selectors/getNextAvailableDates';
import { getPrescriptions } from '~shared/features/prescriptions/selectors/getPrescriptions';
import { type NextAvailableDate, type ReduxStateShared } from '~shared/types';

type NextAvailableDateAddressIDParams = {
  nextAvailableDateAddressID: number | undefined;
};

const getNextAvailableDateAddressID = (_: ReduxStateShared, props: NextAvailableDateAddressIDParams) =>
  props.nextAvailableDateAddressID;

export const getNextAvailableDatesByPrescriptionID = createSelector(
  [getNextAvailableDateAddressID, getNextAvailableDateFacilityID, getPrescriptions, getNextAvailableDates],
  (addressID, facilityID, prescriptions, nextAvailableDates) => {
    const result: Record<number, NextAvailableDate> = {};
    if (!(addressID || facilityID)) {
      return result;
    }
    return prescriptions.reduce((nadByPrescriptionID, prescription) => {
      const nextAvailableDateID = getNextAvailableDateID({
        addressID,
        facilityID,
        prescriptionIDs: [prescription.id],
      });
      nadByPrescriptionID[prescription.id] = nextAvailableDates[nextAvailableDateID];
      return nadByPrescriptionID;
    }, result);
  },
);
